import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = { style: { "padding-bottom": "40px" } };
const _hoisted_2 = { style: { "padding": "15px 0" } };
const _hoisted_3 = { key: 0 };
const _hoisted_4 = { key: 1 };
import { ref, onMounted, watch, computed } from "vue";
import NoSavedVehicles from "@/pages/savedVehicles/components/noSavedVehicles.vue";
import { TranslationService } from "@/services/translationService";
import { CustomEvents } from "@/events/customEvents";
import { getDealerId } from "../../utils/dealerUtils";
export default /*@__PURE__*/ _defineComponent({
    __name: 'savedVehiclesPage',
    setup(__props) {
        const translationService = new TranslationService();
        const dealerId = String(getDealerId());
        const vehicles = ref([]);
        const hasSavedVehicles = ref(false);
        const translations = ref();
        // Title rendered in-Vue (previously a static server <h1>) so it never flashes before hydration.
        const isRvIndustry = computed(() => translations.value?.resources?.["RvIndustry"]?.toLowerCase() === "true");
        const pageTitle = computed(() => {
            const resources = translations.value?.resources;
            const label = isRvIndustry.value ? resources?.["label_mySavedRvs"] : resources?.["label_mySavedVehicles"];
            return label || (isRvIndustry.value ? "My Saved RVs" : "My Saved Vehicles");
        });
        onMounted(async () => {
            vehicles.value = JSON.parse(localStorage.getItem("savedVehicles") ?? "[]");
            hasSavedVehicles.value = vehicles.value.length > 0;
            const response = await translationService.getTranslations(dealerId, "mysavedvehicles");
            translations.value = response ?? { resources: {} };
            document.addEventListener(CustomEvents.ToggleVehicleSave, () => {
                vehicles.value = JSON.parse(localStorage.getItem("savedVehicles") ?? "[]");
            });
            globalThis.addEventListener("do.vehicledeckloaded", (event) => {
                const invalidVins = event.data.invalidVins;
                vehicles.value = vehicles.value.filter((v) => !invalidVins.includes(v));
                localStorage.setItem("savedVehicles", JSON.stringify(vehicles.value));
            });
        });
        watch(vehicles, () => {
            hasSavedVehicles.value = vehicles.value.length > 0;
        });
        return (_ctx, _cache) => {
            const _component_vehicle_card_deck = _resolveComponent("vehicle-card-deck");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("h1", _hoisted_2, _toDisplayString(pageTitle.value), 1 /* TEXT */),
                (hasSavedVehicles.value)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                        _createVNode(_component_vehicle_card_deck, {
                            vins: vehicles.value,
                            "dealer-id": _unref(dealerId)
                        }, null, 8 /* PROPS */, ["vins", "dealer-id"])
                    ]))
                    : (_openBlock(), _createElementBlock("div", _hoisted_4, [
                        _createVNode(NoSavedVehicles, {
                            translations: translations.value
                        }, null, 8 /* PROPS */, ["translations"])
                    ]))
            ]));
        };
    }
});
